export const addParamToUrl = (location, setSearchParams, name, value) => {
  const params = new URLSearchParams(location.search);
  params.append(name, value);
  setSearchParams(Object.fromEntries(params));
};

export const removeParamFromUrl = (location, setSearchParams, name) => {
  const params = new URLSearchParams(location.search);
  params.delete(name);
  setSearchParams(Object.fromEntries(params));
};

export const getRecordIdFromSearchParams = (searchParams, name) => {
  const id = searchParams.get(name);
  return id && parseInt(id, 10);
};
